import { Box, Container, Typography } from '@mui/material';
import Image from 'next/image';

import { middleSectionContent } from '../constant';

import { useStyles } from './useStyles';

const MiddleSection = () => {
  const classes = useStyles();
  return (
    <Box bgcolor="whitePepper.main">
      <Container maxWidth="xl" disableGutters className={classes.mainContainer}>
        {middleSectionContent.map((item) => (
          <Box className={classes.container} key={item.id}>
            <Box
              className={classes.imgContainer}
              sx={{
                borderRadius: item.alt === 'chopChef' ? '50%' : '0',
                overflow: item.alt === 'chopChef' ? 'hidden' : 'auto',
              }}
            >
              <Image
                src={item.icon}
                alt={item.alt}
                layout="fill"
                objectFit="contain"
              />
            </Box>
            <Box className={classes.titleDescriptionContainer}>
              <Typography
                variant="h3"
                color="cinnamon.main"
                className={classes.title}
              >
                {item.title}
              </Typography>
              <Typography
                variant="body1"
                color="garamMasala.main"
                className={classes.description}
              >
                {item.description}
              </Typography>
            </Box>
          </Box>
        ))}
      </Container>
    </Box>
  );
};

export default MiddleSection;
